import { useEffect, useState } from 'react';

const fallbackCenter = {
  lat: 24.7136,
  lng: 46.6753,
};

export function useInitializeLocation(
  openModal,
  shippingAddress,
  setSearchInput,
  setMarkerPosition,
  setMapCenter
) {
  const [initialized, setInitialized] = useState(false);

  const lat = shippingAddress?.custom_attributes?.find(
    (e) => e?.attribute_code === 'lat'
  )?.value;
  const lng = shippingAddress?.custom_attributes?.find(
    (e) => e?.attribute_code === 'lng'
  )?.value;

  useEffect(() => {
    if (!openModal) return;

    const setupFromAddress = () => {
      setSearchInput(shippingAddress?.street?.[0]);
      setMarkerPosition(
        lat && lng ? { lat: Number(lat), lng: Number(lng) } : null
      );
      setMapCenter(lat && lng ? { lat: Number(lat), lng: Number(lng) } : null);
      setInitialized(true);
    };

    const setupFromGeolocation = () => {
      if (!navigator.geolocation) {
        setMapCenter(fallbackCenter);
        setMarkerPosition(fallbackCenter);
        setInitialized(true);
        return;
      }

      navigator.geolocation.getCurrentPosition(
        async (pos) => {
          const coords = {
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          };
          setMarkerPosition(coords);
          setMapCenter(coords);

          try {
            const geocoder = new window.google.maps.Geocoder();
            const response = await geocoder.geocode({ location: coords });
            const address = response?.results?.[0]?.formatted_address || '';
            const country =
              response?.results?.[0]?.address_components?.find((c) =>
                c.types.includes('country')
              )?.long_name || '';
            setSearchInput(country ? `${address} (${country})` : address);
          } catch {
            setSearchInput(
              `${coords.lat.toFixed(6)}, ${coords.lng.toFixed(6)}`
            );
          }

          setInitialized(true);
        },
        () => {
          setMapCenter(fallbackCenter);
          setMarkerPosition(fallbackCenter);
          setInitialized(true);
        }
      );
    };

    if (shippingAddress?.street?.[0] && lat && lng) {
      setupFromAddress();
    } else {
      setupFromGeolocation();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModal]);

  return initialized;
}
